
  <div class="InventoryFinancial Inventory">
    <div>
      <div class="fx-xs-column fx-row fx-align-space-between-center">
        <div class="fx-row fx-align-start-center fx-flex-30">
          <app-count-header title="{{inventory?.invBatchName}}"></app-count-header>
        </div>
        <h2 class="text-center w-100 fx-flex-30">{{ "report.value" | translate }}</h2>
        <div class="flex fx-align-end-center fx-flex-30">
          <div class="fx-row fx-gap-20px fx-layout-lt-md-column">
            <button mat-raised-button color="primary" (click)="sendReport()" class="fx-align-simple-center">
              {{ "sendReport" | translate }}
            </button>
            <app-select-report></app-select-report>
            <button mat-raised-button color="primary" (click)="generatePDF()" class="fx-align-simple-center">
              {{ "generatePDF" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <app-mid-header [inventory]="inventory"></app-mid-header>
    <div class="fixed-table">
      <table mat-table [dataSource]="dataSource" matSort (matSortChange)="onSortData($event)" width="100%">

        <ng-container matColumnDef="prdCode">
          <mat-header-cell *matHeaderCellDef  mat-sort-header> {{ "form.product.prdCode" | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="flex-header">
            <span class="mobile-label">SKU</span>
            <span [innerHTML]="element.prdCode"></span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="prdNameEn">
          <mat-header-cell *matHeaderCellDef  mat-sort-header> {{ "products.table.prdNameEn" | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="flex-header">
            <span class="mobile-label">{{ "products.table.prdNameEn" | translate }}</span>
            <span [innerHTML]="element.prdNameEn"></span>
            <span *ngIf="element.isCombined" style="color: red;"> *</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="prdCasePack">
          <mat-header-cell *matHeaderCellDef  mat-sort-header>UOM</mat-header-cell>
          <mat-cell *matCellDef="let element" class="flex-header">
            <span class="mobile-label">UOM</span>
            <span>{{ element.prdCasePack }}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="invitmCount">
          <mat-header-cell *matHeaderCellDef  mat-sort-header> {{ "inventory.count" | translate }} </mat-header-cell>
          <mat-cell *matCellDef="let element" class="flex-header">
            <span class="mobile-label">{{ "inventory.count" | translate }}</span>
            <span>{{ element.invitmCount }}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="pcmCost">
          <mat-header-cell *matHeaderCellDef  mat-sort-header> {{ "inventory.costPerUnit" | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="flex-header">
            <span class="mobile-label">{{ "inventory.costPerUnit" | translate }}</span>
            <span>${{ element.pcmCost | number:'1.2-2' }}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="pcmRetail">
          <mat-header-cell *matHeaderCellDef  mat-sort-header> {{ "inventory.retail" | translate }} </mat-header-cell>
          <mat-cell *matCellDef="let element" class="flex-header">
            <span class="mobile-label">{{ "inventory.retail" | translate }}</span>
            <span>${{ element.pcmRetail | number:'1.2-2' }}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="totalCost">
          <mat-header-cell *matHeaderCellDef="totalCost"  mat-sort-header> {{ "inventory.totalCost" | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="flex-header">
            <span class="mobile-label">{{ "inventory.totalCost" | translate }}</span>
            <span>${{element.totalCost | number:'1.2-2'}}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="totalRetail">
          <mat-header-cell *matHeaderCellDef  mat-sort-header> {{ "inventory.totalRetail" | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="flex-header">
            <span class="mobile-label">{{ "inventory.totalRetail" | translate }}</span>
            <span>${{element.totalRetail | number:'1.2-2'}}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="totalProfit">
          <mat-header-cell *matHeaderCellDef class="text-right"  mat-sort-header> {{ "inventory.availProfit" | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="flex-header">
            <span class="mobile-label">{{ "inventory.availProfit" | translate }}</span>
            <span>${{ element.totalProfit | number:'1.2-2'}}</span>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;" appInventoryRow [prdID]="row.prdID" [invitmID]="row.invitmID"></mat-row>
      </table>

      <br />
      <br />

      <table class="bottom-table">
        <thead>
          <tr>
            <th>{{ "total" | translate }} {{ "inventory.costValue" | translate }}</th>
            <th>{{ "total" | translate }} {{ "inventory.retailValue" | translate }}</th>
            <th>{{ "inventory.availProfit" | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>${{inventory?.tmpCostTotal | number:'1.2-2'}}</td>
            <td>${{inventory?.tmpRetailTotal | number:'1.2-2'}}</td>
            <td>${{inventory?.tmpCalcProfitTotal | number:'1.2-2'}}</td>
          </tr>
        </tbody>
      </table>
      <table class="bottom-table alert-message" *ngIf="hasAsteriskProducts">
        <tr>
          <td>{{ "message_asterisk" | translate }}</td>
        </tr>
      </table>
    </div>
  </div>
